import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4de46df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Choose from one of the available images. ", -1))
const _hoisted_2 = { class: "ion-item-image--wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  style: {"margin":"1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonSearchbar = _resolveComponent("IonSearchbar")!
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonRadio = _resolveComponent("IonRadio")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonThumbnail = _resolveComponent("IonThumbnail")!
  const _component_IonSpinner = _resolveComponent("IonSpinner")!
  const _component_IonList = _resolveComponent("IonList")!
  const _component_IonRadioGroup = _resolveComponent("IonRadioGroup")!
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      name: "thumbForm",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_IonSearchbar, {
        mode: "md",
        class: "max-width center",
        name: "cardSearchField",
        placeholder: "Search for an image",
        modelValue: _ctx.imageQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageQuery) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_IonRadioGroup, {
        modelValue: _ctx.identifier,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.identifier) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonList, null, {
            default: _withCtx(() => [
              _createVNode(_component_IonItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_IonLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode("No Image")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_IonRadio, {
                    mode: "ios",
                    value: undefined
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbResultPage, (thumb) => {
                return (_openBlock(), _createBlock(_component_IonItem, {
                  key: thumb.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_IonThumbnail, null, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: thumb.url
                          }, null, 8, _hoisted_3)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("p", {
                        title: thumb.tags ? thumb.tags.map(({name}) => name).join() : thumb.name || thumb.title
                      }, [
                        _createTextVNode(_toDisplayString(thumb.name || thumb.title) + " ", 1),
                        (thumb.source)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("(" + _toDisplayString(thumb.source) + ")", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_4)
                    ]),
                    _createVNode(_component_IonRadio, {
                      mode: "ios",
                      value: _ctx.isInternal(thumb) ? thumb.id : thumb
                    }, null, 8, ["value"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_ctx.ccPageBeingLoaded !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_IonSpinner)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, "Page " + _toDisplayString(_ctx.resultPage) + " of " + _toDisplayString(_ctx.maxPossiblePages), 1),
              (_ctx.resultPage > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
                  }, "Previous"))
                : _createCommentVNode("", true),
              (_ctx.resultPage < _ctx.maxPossiblePages)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                  }, "Next"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 32),
    _createVNode(_component_IonButton, {
      class: "select-image--return",
      color: "secondary",
      fill: "outline",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dismiss()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IonIcon, { icon: _ctx.returnDownBackOutline }, null, 8, ["icon"]),
        _createTextVNode(" Done ")
      ]),
      _: 1
    })
  ], 64))
}